import { Pipe, PipeTransform } from '@angular/core';
declare var $: any;
@Pipe({
  name: 'noRepeat'
})
export class NoRepeatPipe implements PipeTransform {
  transform(arr: any): any {
    var obj: any = {};
    for ( var i=0, len=arr.length; i < len; i++ )
        obj[arr[i]['adress']] = arr[i];

    arr = new Array();
    for ( var key in obj )
        arr.push(obj[key]);



    return arr

}

}
